export default "__VITE_ASSET__CNrP7dXA__"